module.exports = __webpack_public_path__ + "img/labmem_icon_fb.9cf067bd.png";